import { Typography } from '@mui/material';
import { FinalWithBookingWidget } from './final-with-booking-widget';

const FinalChoseNoMatch = () => (
  <FinalWithBookingWidget>
    <Typography paragraph>
      Thanks for completing your assessment. It looks like we haven't found the
      right clinician for your needs yet.
    </Typography>
    <Typography paragraph>
      We can still help you find the right match. Schedule a quick call with one
      of our care coordinators. We'll ask you a few follow-up questions (be sure
      to have your insurance card handy) and help you book your first visit.
    </Typography>
  </FinalWithBookingWidget>
);

export default FinalChoseNoMatch;
